import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { PartnerEndpoint } from '../constants/partner-endpoint';
import { PartnerBrief, PartnerListSearchCriteria, PartnerSearchCriteria } from '../models';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { ListObject } from '../../../../../common/models';
import { PartnerListStateModel } from './partner-list.state';

@Injectable({
  providedIn: 'root',
})
export class PartnerListService {
  constructor(private http: WrapperHttpService) {}

  getPartnerList({ size, page, ...filterView }: PartnerSearchCriteria): Observable<ListObject<PartnerBrief>> {
    const url = `${API_URL}${PartnerEndpoint.Base}${PartnerEndpoint.Search}?${getQueryStringFromObject({
      page,
      size,
    })}`;
    return this.http.withLoading().post<PartnerListStateModel>(url, filterView);
  }

  startExportToFile(body: { name: string; filterView: Partial<PartnerListSearchCriteria> }): Observable<void> {
    const url = `${API_URL}${PartnerEndpoint.Exports}${PartnerEndpoint.Base}` + '?name=' + body.name;
    return this.http.withLoading().post<void>(url, body.filterView);
  }

  getPartnerListByFilter({
    page,
    size,
    partnerType,
    active,
    name,
  }: PartnerListSearchCriteria): Observable<ListObject<PartnerBrief>> {
    const url = `${API_URL}${PartnerEndpoint.Base}?${getQueryStringFromObject({
      page,
      size,
      types: partnerType,
      active,
      filter: name,
    })}`;
    return this.http.withLoading().get<PartnerListStateModel>(url);
  }
}
